// A tela é da rota-pai (`admin.withdrawals.tsx`), porque ela continua desenhada embaixo
// quando o detalhe abre no drawer (`spec/24` §1 decisão 5). Esta rota-índice existe só
// para `/admin/withdrawals` ser um destino válido do roteador.

import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/withdrawals/')({ component: () => null });
